import React from 'react';
import { Row, Col, Switch } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';
import FormField from '../../shared/FormField';
import SelectField from '../../shared/SelectField';
import CurrencyInput from '../../shared/CurrencyInput';
import { useValorExtenso } from '../../../hooks/useValorExtenso';
import { ORIGENS_LEAD } from '@engenharia/shared';

const ORIGEM_OPTIONS = ORIGENS_LEAD.map((o) => ({ label: o, value: o }));

export default function PropostaComercialSection() {
  const { watch, control } = useFormContext();
  const valorProposta = watch('valor_proposta');
  const origemLead = watch('origem_lead');
  const propostaCrm = watch('proposta_crm');
  const extenso = useValorExtenso(valorProposta);

  return (
    <div className="border rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-4">Proposta Comercial</h3>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <CurrencyInput name="valor_proposta" label="Valor da Proposta" required />
          {extenso && (
            <p className="text-xs text-gray-500 -mt-2 mb-2 italic">({extenso})</p>
          )}
        </Col>
        <Col xs={24} sm={12}>
          <SelectField name="origem_lead" label="Origem do Lead" options={ORIGEM_OPTIONS} />
        </Col>
      </Row>

      {origemLead === 'Pré Vendas' && (
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <FormField name="pre_vendedor" label="Pré-Vendedor" />
          </Col>
        </Row>
      )}

      <Row gutter={16} className="items-center">
        <Col xs={24} sm={12}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Proposta CRM</label>
            <Controller
              name="proposta_crm"
              control={control}
              render={({ field }) => (
                <Switch checked={field.value} onChange={field.onChange} />
              )}
            />
          </div>
        </Col>
        {propostaCrm && (
          <Col xs={24} sm={12}>
            <FormField name="numero_proposta" label="Número da Proposta" />
          </Col>
        )}
      </Row>
    </div>
  );
}
